import {ChangeDetectionStrategy, Component, HostBinding, inject} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {Button, ButtonDirective, ButtonIcon} from "primeng/button";
import {RouterLink} from "@angular/router";
import {HomeyDialogService} from "../../../services/homey-dialog.service";
import {FeedbackDialogComponent} from "../../feedback-dialog/feedback-dialog.component";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'homey-header-buttons',
  imports: [
    Button,
    ButtonDirective,
    ButtonIcon,
    RouterLink
  ],
  templateUrl: './header-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderButtonsComponent {
  @HostBinding('class') readonly hostClass = 'h-full flex flex-row gap-2 items-center';
  private readonly userService = inject(UserService);
  private readonly dialogService = inject(HomeyDialogService);
  protected readonly user = this.userService.user;

  public onFeedbackClick() {
    this.dialogService.showDialogWithHeader(FeedbackDialogComponent, 'Share your feedback', {});
  }

  protected readonly environment = environment;
}
